module.exports = __webpack_public_path__ + "img/triangle-services-right.ad4fe735.png";